const initialState = {
    init: false,
    invoice_modal: {
        display: false,
        ipn: false,
        payer: false,
        id: false,
        creation: false,
        paymentsInfos: false
    },
    payments : [],
    step: 1,
    vip: 3,
    subscriptionTime: 12,
    paymentType: "subscription",
    paymentMethod: false
};
  
export const payments = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_PAYMENT_TYPE' : {
            return {
                ...state,
                paymentType: action.paymentType
            }
        }
        case 'UPDATE_SUB_TIME': {
            return {
                ...state,
                subscriptionTime: action.subTime
            }
        }
        case 'UPDATE_STEP': {
            return {
                ...state,
                step: action.step,
                paymentMethod: false
            }
        }
        case 'UPDATE_VIP_SELECTED': {
            return {
                ...state,
                step: initialState.step,
                subscriptionTime: initialState.subscriptionTime,
                vip: action.vip
            }
        }
        case 'UPDATE_PAYMENT_METHOD': {
            return {
                ...state,
                paymentMethod: action.paymentMethod
            }
        }
        case 'CANCEL_SUBSCRIPTION': {
            const index = state.payments.findIndex((p) => p.id === action.id);
            if (index === -1) return state;
            let newPayments = [...state.payments];
            newPayments[index].active = false;
            return {
                ...state,
                payments: newPayments
            }
        }
        case 'PAYMENT_CLOSE_MODAL': {
            return {
                ...state,
                invoice_modal: {
                    ...state.invoice_modal,
                    display: false
                }
            };
        }
        case 'PAYMENT_SET_MODAL': {
            return {
                ...state,
                invoice_modal: {
                    ...state.invoice_modal,
                    display: true,
                    payer: action.payer,
                    id: action.id,
                    creation: action.creation,
                    paymentInfos: action.paymentInfos
                }
            };
        }
        case 'PAYMENTS_SET_LIST': {
            return {
                ...state,
                init: true,
                payments: action.list
            };
        }
        default:
            return state;
    }
};